import { render } from "./CalendarIcon.vue?vue&type=template&id=2724a264&scoped=true"
const script = {}

import "./CalendarIcon.vue?vue&type=style&index=0&id=2724a264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2724a264"]])

export default __exports__